import React, { useContext, useState } from "react";
import axios from "axios";
import { apiRoot } from "../../index";
import { UserContext } from "../../App";

export default function ImportTSPData() {
  const { userInfos } = useContext(UserContext);

  const [clientFile, setClientFile] = useState(null);
  const [contactFile, setContactFile] = useState(null);
  const [passengerFile, setPassengerFile] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  function handleClientFileChange(e) {
    setClientFile(e.target.files[0]);
  }

  function handleContactFileChange(e) {
    setContactFile(e.target.files[0]);
  }

  function handlePassengerFileChange(e) {
    setPassengerFile(e.target.files[0]);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (clientFile && contactFile) {
      setIsUploading(true);

      const formData = new FormData();
      formData.append("tsp_clients", clientFile);
      formData.append("tsp_contacts", contactFile);
      formData.append("tsp_passengers", passengerFile);

      try {
        const response = await axios.post(
          `${apiRoot}/api/v1/import/tsp-data`,
          formData,
          {
            headers: {
              Authorization: userInfos.jwt,
            },
          }
        );

        console.log("Importation réussie :", response.data);
        alert("Import réussi !");
      } catch (error) {
        console.error("Erreur pendant l'upload :", error);
        alert(
          "Erreur lors de l'importation : " +
            (error.response?.data?.error || error.message)
        );
      } finally {
        setIsUploading(false);
      }
    } else {
      alert("Veuillez sélectionner les deux fichiers.");
    }
  }

  return (
    <form onSubmit={handleSubmit} encType="multipart/form-data">
      <div className="form-group row">
        <label className="col-lg-3 col-form-label">Fichier Clients :</label>
        <div className="col-lg-6 d-flex align-items-center">
          <input
            type="file"
            name="tsp_clients"
            id="tsp_clients_file"
            accept=".csv"
            onChange={handleClientFileChange}
            disabled={isUploading}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-lg-3 col-form-label">Fichier Contacts :</label>
        <div className="col-lg-6 d-flex align-items-center">
          <input
            type="file"
            name="tsp_contacts"
            id="tsp_contacts_file"
            accept=".csv"
            onChange={handleContactFileChange}
            disabled={isUploading}
          />
        </div>
      </div>
      <div className="form-group row">
        <label className="col-lg-3 col-form-label">Fichier Passagers :</label>
        <div className="col-lg-6 d-flex align-items-center">
          <input
            type="file"
            name="tsp_passengers"
            id="tsp_passengers_file"
            accept=".csv"
            onChange={handlePassengerFileChange}
            disabled={isUploading}
          />
        </div>
      </div>
      <div className="form-group row">
        <div className="col-lg-9 offset-lg-3">
          <button
            type="submit"
            className="btn btn-primary"
            disabled={
              !clientFile || !contactFile || !passengerFile || isUploading
            }
          >
            {isUploading ? "Import en cours..." : "Importer"}
          </button>
          {(!clientFile || !contactFile || !passengerFile) && (
            <>
              <br />
              <small className="text-danger">
                Vous devez renseigner les 3 fichiers
              </small>
            </>
          )}
        </div>
      </div>
    </form>
  );
}
